export const FOUND_WRAPPER_CLASS_NAME = "foundNode";
export const FOUND_NODE_CLASS_NAME = "found";

export const ACTIVE_SEARCH_TERM_ID = "currentSearchTerm";

export const HIDDEN_TABLE_CLASS_NAME = "HiddenTable";

export const DEFAULT_HIGHLIGHT_COLOR = "#fae83b";
export const ACTIVE_HIGHLIGHT_COLOR = "#fac93b";

export const MATCH_NAV_DIRECTION = { PREV: "prev", NEXT: "next" };
export const MATCH_TYPE = { SECTION: "SECTION", TABLE: "TABLE" };

export const MATCH_SCROLL_OFFSET_PX = 250;

export const findOnPageSearchBarAttr = {
  findInSection: "FindInSectionInput",
  findInTopic: "FindInTopicInput",
  findInQuickAnswers: "FindInQuickAnswersInput",
};

export const findOnPageSearchBarDataTestIds = {
  findInSection: "find-in-section-input",
  findInTopic: "find-in-topic-input",
  findInQuickAnswers: "find-in-quick-answers-input",
};
